import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {

  transform(value: any[], field: string): unknown {
    
    if(value){
      return value.sort((obj1, obj2) => {
        return obj1[field] - obj2[field];
      });
    }
    return null;
  }

}
